<template>
  <v-list-item :to="{name: 'contact_histories_email', params: {
    id: contactHistory.KundenNr,
    contact_history_id: contactHistory.Nr,
    email_id: email.Id,
  }}">
    <v-list-item-title style="white-space: normal;">
      {{ email.Datei.Dateiname ?? 'Kein Betreff' }}
    </v-list-item-title>
    <v-list-item-subtitle>
      {{ email.AnlageDatumFormatted }}
    </v-list-item-subtitle>
    <template #append>
      <v-icon :color="email.color">{{ email.stateIcon }}</v-icon>
    </template>
  </v-list-item>
</template>

<script setup lang="ts">
import {PropType} from 'vue';
import {ContactHistoryEmail} from '@/model/ContactHistoryEmail';
import ContactHistory from '@/model/ContactHistory';

const props = defineProps({
  email: {
    type: Object as PropType<ContactHistoryEmail>,
    required: true,
  },
  contactHistory: {
    type: Object as PropType<ContactHistory>,
    required: true,
  },
});

defineExpose({
  props,
});
</script>
